import { NgModule, ModuleWithProviders } from "@angular/core";

import { ODRController } from "./odr-controller";

@NgModule({})
export class ODRModule {
  static forRoot(): ModuleWithProviders<ODRModule> {
    return {
      ngModule: ODRModule,
      /* SINGLETON PROVIDERS MUST BE DEFINED HERE */
      providers: [ODRController],
    };
  }
}
